import type { ApiConfig } from '../../types'

/**
 * Backpack の約定履歴 API 設定。
 * `/wapi/v1/history/fills` (instruction: fillHistoryQueryAll) を利用する。
 * 1 リクエストあたり最大 1000 件まで取得可能。
 */
export const fillHistoryApiConfig = {
  existSubType: false,
  fetchableRange: undefined,
  limit: 1000,
  order: 'desc',
  range: undefined,
  requiresRange: false,
  type: 'fill-history',
} as const satisfies ApiConfig
